import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Earnings")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bold text-gray-500 mb-4" }, " Last 30 day earnings calculated. Apart from arranging the order of topics. ", -1)
const _hoisted_4 = { class: "d-flex flex-wrap flex-stack mb-5" }
const _hoisted_5 = { class: "d-flex flex-wrap" }
const _hoisted_6 = { class: "border border-dashed border-gray-300 w-150px rounded my-3 p-4 me-6" }
const _hoisted_7 = { class: "fs-1 fw-bolder text-gray-800 lh-1" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  "data-kt-countup": "true",
  "data-kt-countup-value": "6,840",
  "data-kt-countup-prefix": "$"
}, "6,840$", -1)
const _hoisted_9 = { class: "svg-icon svg-icon-1 svg-icon-success" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-muted d-block lh-1 pt-2" }, "Net Earnings", -1)
const _hoisted_11 = { class: "border border-dashed border-gray-300 w-125px rounded my-3 p-4 me-6" }
const _hoisted_12 = { class: "fs-1 fw-bolder text-gray-800 lh-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", {
  class: "",
  "data-kt-countup": "true",
  "data-kt-countup-value": "16"
}, "16", -1)
const _hoisted_14 = { class: "svg-icon svg-icon-1 svg-icon-danger" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-muted d-block lh-1 pt-2" }, "Change", -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"border border-dashed border-gray-300 w-150px rounded my-3 p-4 me-6\"><span class=\"fs-1 fw-bolder text-gray-800 lh-1\"><span data-kt-countup=\"true\" data-kt-countup-value=\"1,240\" data-kt-countup-prefix=\"$\">1,240$</span><span class=\"text-primary\">--</span></span><span class=\"fs-6 fw-bold text-muted d-block lh-1 pt-2\">Fees</span></div>", 1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("a", {
  href: "#",
  class: "btn btn-sm btn-light-primary flex-shrink-0"
}, "Withdraw Earnings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`card ${_ctx.cardClasses}`)
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg, {
                  src: "/media/icons/duotune/arrows/arr066.svg",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _hoisted_10
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("span", _hoisted_12, [
              _hoisted_13,
              _createTextVNode("% "),
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_inline_svg, {
                  src: "icons/duotune/arrows/arr065.svg",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _hoisted_15
          ]),
          _hoisted_16
        ]),
        _hoisted_17
      ])
    ])
  ], 2))
}